const ArrowRightShort = props => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.5543 6.69426C11.9448 7.08479 11.9448 7.71795 11.5543 8.10847L5.19036 14.4724C4.79984 14.863 4.16667 14.863 3.77615 14.4724C3.38563 14.0819 3.38563 13.4487 3.77615 13.0582L9.43301 7.40137L3.77615 1.74451C3.38563 1.35399 3.38563 0.720824 3.77615 0.3303C4.16668 -0.0602247 4.79984 -0.0602247 5.19036 0.3303L11.5543 6.69426ZM0.990234 6.40137L10.8472 6.40137L10.8472 8.40137L0.990234 8.40137L0.990234 6.40137Z"
    />
  </svg>
)

export default ArrowRightShort
